import { render, staticRenderFns } from "./TrendedPublications.vue?vue&type=template&id=a253326e&"
import script from "./TrendedPublications.vue?vue&type=script&lang=js&"
export * from "./TrendedPublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports